import router from "@/router";
import jwt_decode from "jwt-decode";
import { default as permissions } from "@/@core/data/permissions";
let token_permissions = [...permissions];
let subscription_id = null;
let token = {};
let tokenKeys = [];
let accessToken = localStorage.getItem("accessToken");
if (accessToken) {
  token = jwt_decode(accessToken);
  subscription_id = token.current_subscription_id;
  if (!!token.permission) {
    tokenKeys = token.permission.length
      ? token.permission
      : token_permissions.map((p) => p.key);
  } else {
    localStorage.clear();
    sessionStorage.clear();
    router.push("/login");
  }
}

function accessEmployee(...fields) {
  return fields.some((role) => tokenKeys.includes(role));
}
function accessSubscription(...fields) {
  return fields.includes(subscription_id);
}

export default [
  {
    title: "داشبورد",
    route: "home",
    icon: "HomeIcon",
  },
  {
    title: "سفارشات",
    icon: "ShoppingBagIcon",
    children: [
      {
        title: "سفارشات روزانه",
        route: "daily-orders",
        disabled:
          !accessSubscription(2, 3) || !accessEmployee("daily_orders_view"),
      },
      {
        title: "ثبت پیش‌سفارش",
        route: "pre-invoice",
        disabled:
          !accessSubscription(2, 3) || !accessEmployee("preorder_create"),
      },
      {
        title: "ثبت سفارش",
        route: "invoice-registration",
        disabled: !accessSubscription(2, 3) || !accessEmployee("order_create"),
      },
      {
        title: "جزئیات سفارش",
        route: "invoice-details",
        disabled:
          !accessSubscription(2, 3) || !accessEmployee("order_details_view"),
      },
      {
        title: "گزارش سفارشات",
        route: "daily-sales-report",
        disabled:
          !accessSubscription(2, 3) || !accessEmployee("cashier_orders_view"),
      },
      {
        title: "گزارش سفارشات آنلاین",
        route: "online-orders",
        disabled:
          !accessSubscription(3) || !accessEmployee("online_orders_view"),
      },
      {
        title: "گزارش جامع سفارشات",
        route: "advanced-sales-report",
        disabled:
          !accessSubscription(2, 3) ||
          !accessEmployee("comprehensive_orders_view"),
      },
      {
        title: "چاپگر خودکار سفارشات",
        route: "chef-invoice",
        disabled:
          !accessSubscription(2, 3) || !accessEmployee("auto_order_print"),
      },
    ],
  },
  {
    title: "محصولات",
    icon: "CoffeeIcon",
    children: [
      {
        title: "دسته‌بندی",
        route: "categories",
        disabled: !accessEmployee("categories_products_view"),
      },
      {
        title: "محصولات",
        route: "products",
        disabled: !accessEmployee("categories_products_view"),
      },
      {
        title: "گزارش فروش",
        route: "product-orders",
        disabled:
          !accessSubscription(2, 3) || !accessEmployee("products_sales_report"),
      },
    ],
  },
  {
    title: "باشگاه مشتریان",
    icon: "UsersIcon",
    children: [
      {
        title: "مشتریان",
        route: "customers",
        disabled:
          !accessSubscription(2, 3) || !accessEmployee("customers_view"),
      },
      {
        title: "امتیاز و نظرات",
        route: "ratings-and-comments",
        disabled:
          !accessSubscription(3) || !accessEmployee("manage_customer_comments"),
      },
      {
        title: "اعتبار و کیف پول",
        route: "credit-and-wallet",
        disabled:
          !accessSubscription(3) ||
          !accessEmployee("customer_wallet_changes_report"),
      },
      {
        title: "سطوح و امتیازات",
        route: "score-management",
        disabled:
          !accessSubscription(3) || !accessEmployee("loyalty_changes_report"),
      },
      {
        title: "کمپین‌های هوشمند",
        route: "smart-campaigns",
        disabled: !accessSubscription(3) || !accessEmployee("campaigns_report"),
      },
      {
        title: "تنظیمات باشگاه",
        route: "customer-club",
        disabled: !accessSubscription(3) || !accessEmployee("loyalty_settings"),
      },
    ],
  },
  {
    title: "پیامک",
    icon: "MessageCircleIcon",
    children: [
      {
        title: "گزارش ارسال",
        route: "sms-sent-messages",
        disabled: !accessSubscription(3) || !accessEmployee("sent_sms_report"),
      },
      {
        title: "ارسال گروهی",
        route: "sms-send",
        disabled: !accessSubscription(3) || !accessEmployee("send_bulk_sms"),
      },
      {
        title: "الگوهای سیستمی",
        route: "sms-management",
        disabled: !accessSubscription(3) || !accessEmployee("sms_settings"),
      },
      {
        title: "گزارش شارژ حساب",
        route: "sms-account-report",
        disabled:
          !accessSubscription(3) || !accessEmployee("sms_charges_report"),
      },
    ],
  },
  {
    title: "انبار",
    icon: "BoxIcon",
    tagVariant: "light-secondary",
    children: [
      {
        title: "دسته‌بندی مواد اولیه",
        route: "raw-material-category",
        disabled:
          !accessSubscription(3) ||
          !accessEmployee("warehouse_categories_materials_create"),
      },
      {
        title: "مواد اولیه",
        route: "raw-material",
        disabled:
          !accessSubscription(3) ||
          !accessEmployee("warehouse_categories_materials_create"),
      },
      {
        title: "اشخاص",
        route: "people",
        disabled:
          !accessSubscription(3) || !accessEmployee("warehouse_people_manage"),
      },
      {
        title: "انبارها",
        route: "warehouses",
        disabled:
          !accessSubscription(3) || !accessEmployee("warehouses_manage"),
      },
      {
        title: "فاکتور انبار",
        route: "warehouse-invoice",
        disabled:
          !accessSubscription(3) || !accessEmployee("warehouse_invoices_view"),
      },
      {
        title: "انبارگردانی",
        route: "stock-taking",
        disabled:
          !accessSubscription(3) || !accessEmployee("stock_takings_view"),
      },
      {
        title: "گزارش ورود و خروج انبار",
        route: "stock-movements",
        disabled:
          !accessSubscription(3) || !accessEmployee("stock_movements_view"),
      },
    ],
  },
  {
    title: "مالی",
    icon: "CreditCardIcon",
    tag: "به‌زودی",
    tagVariant: "light-secondary",
    children: [
      {
        title: "دسته‌بندی هزینه‌ها",
        route: "",
        disabled: true,
      },
      {
        title: "هزینه‌ها",
        route: "",
        disabled: true,
      },
    ],
  },
  {
    title: "اشتراک",
    icon: "CalendarIcon",
    children: [
      {
        title: "گزارش اشتراک",
        route: "transactions",
        disabled: !accessEmployee("subscription_management"),
      },
      {
        title: "مدیریت اشتراک",
        route: "subscription-management",
        disabled: !accessEmployee("subscription_management"),
      },
    ],
  },
  {
    title: "تنظیمات",
    icon: "SettingsIcon",
    children: [
      {
        title: "تنظیمات پایه",
        route: "basic-settings",
        disabled: !accessEmployee("basic_settings"),
      },
      {
        title: "تصاویر درباره ما",
        route: "pictures-about-us",
        disabled: !accessEmployee("about_us_images_settings"),
      },
      {
        title: "ساعت کاری",
        route: "work-schedule",
        disabled: !accessEmployee("work_schedule_settings"),
      },
      {
        title: "جایگاه‌ها",
        route: "table-settings",
        disabled:
          !accessSubscription(1, 2, 3) || !accessEmployee("manage_tables"),
      },
      {
        title: "چاپگر",
        route: "printer-settings",
        disabled:
          !accessSubscription(2, 3) || !accessEmployee("printer_settings"),
      },
      {
        title: "کارکنان",
        route: "user-management",
        disabled: !accessSubscription(2, 3) || !token.is_store_owner,
      },
      {
        title: "اطلاعات مدیر",
        route: "identity-management",
        disabled: !token.is_store_owner,
      },
    ],
  },
  {
    title: "درخواست‌های سالن‌دار",
    route: "waiter-requests",
    icon: "BellIcon",
    disabled: !accessEmployee("hall_requests"),
  },
  {
    title: "پشتیبانی",
    route: "tickets",
    icon: "MessageSquareIcon",
    disabled: !accessEmployee("tickets_view_create"),
  },
];
